import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import './index.css';
import App from './App';
import { theme } from './theme';
import reportWebVitals from './reportWebVitals';
import { bootstrapAppSettings } from './hooks/useAppSettings';

// Warm the app-settings cache before the first React render so module-
// level consumers (e.g. ``timeWindowResolver`` → ``pricingRules``) see
// the admin-configured business hours on first evaluation. Failures are
// non-fatal — the resolver falls back to ``BUSINESS_HOURS_DEFAULT``.
bootstrapAppSettings().catch(() => {
  /* fall back to defaults — error already logged by the fetcher */
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
